import React from 'react';
import { Accordion, AccordionItem } from "react-sanfona";

import './AccordionOptions.css';


export default function (props) {

  return (
    <div className="defaultcard_suggestions">
      {props.suggestions.actions ?
        <Accordion>
          {props.suggestions.actions.map((act, ind) => {
            return (<AccordionItem key={ind} title={act.title} expanded={false}>
            <div>
              {act.value}
            </div>
          </AccordionItem>);
          })}
        </Accordion> : <div></div>}
    </div>
  );
}